export const MobileRoutes = [{
  path: '/Mobile',
  component: () => import('./Mobile.vue'),
  children: [{
      path: '',
      component: () => import('../index.vue'),
      meta: {
        auth: false, // 标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
      }
    }, {
      path: 'evaluationList',
      name: '测评中心wap',
      component: () => import('../evaluationList.vue'),
      meta: {
        auth: false, //标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
        //页面是否需要缓存
        // keepAlive:true
      },
    }, {
      path: 'evaluationDetail',
      name: '测评详情wap',
      component: () => import('../evaluationDetail.vue'),
      meta: {
        auth: false, //标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
      },
    }, {
      path: 'certificate',
      name: '测评中心-证书查询wap',
      component: () => import('../certificate.vue'),
      meta: {
        auth: false, //标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
      },
    }, {
      path: 'agencyList',
      name: '测评中心-机构一览-湖北省办公室wap',
      component: () => import('../agencyList.vue'),
      meta: {
        auth: false, //标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
        //页面是否需要缓存
        // keepAlive:true
      },
    },{
    path: 'organization',
    name: '测评中心-机构一览-合作机构wap',
    component: () => import('../organization'),
    meta: {
      auth: false, //标明是否需要登录后才能访问
      showLogin: true, // 是否显示底部登录注册按钮
    },
  },
    {
      path: 'cooperationDetail',
      name: '机构详情wap',
      component: () => import('../cooperationDetail'),
      meta: {
        auth: false, //标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
      },
    },{
      path: 'courseList',
      name: '测评课程wap',
      component: () => import('../courseList.vue'),
      meta: {
        auth: false, //标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
        // keepAlive:true, //页面是否需要缓存
      },
    }, {
      path: 'courseDetail',
      name: '测评课程详情wap',
      component: () => import('../courseDetail.vue'),
      meta: {
        auth: false, //标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
      },
    }, {
      path: 'evaluationInfo',
      name: '测评报名wap',
      component: () => import('../evaluationInfo'),
      meta: {
        auth: false, //标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
      },
    }, {
      path: 'teacherList',
      name: '艺海撷英-专家团队wap',
      component: () => import('../teacherList.vue'),
      meta: {
        auth: false, //标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
        // keepAlive:true, //页面是否需要缓存

      },
    }, {
      path: 'studentList',
      name: '艺海撷英-明日之星wap',
      component: () => import('../studentList.vue'),
      meta: {
        auth: false, //标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
        // keepAlive:true, //页面是否需要缓存
      },
    }, {
      path: 'studentDetail',
      name: '艺海撷英-明日之星详情wap',
      component: () => import('../studentDetail'),
      meta: {
        auth: false, //标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
      },
    }, {
      path: 'teacherDetail',
      name: '艺海撷英-专家团队详情wap',
      component: () => import('../teacherDetail.vue'),
      meta: {
        auth: false, //标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
      },
    }, {
      path: 'activityList',
      name: '活动比赛-正在进行wap',
      component: () => import('../activityList.vue'),
      meta: {
        auth: false, //标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
      },
    }, {
      path: 'activityHistory',
      name: '活动比赛-历史回顾wap',
      component: () => import('../activityHistory.vue'),
      meta: {
        auth: false, //标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
      },
    }, {
      path: 'activityDetail',
      name: '正在进行-活动详情wap',
      component: () => import('../activityDetail.vue'),
      meta: {
        auth: false, //标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
      },
    }, {
      path: 'historyDetail',
      name: '历史回顾-活动详情wap',
      component: () => import('../historyDetail'),
      meta: {
        auth: false, //标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
      },
    },{
      path: 'activityEventInfo',
      name: '活动报名wap',
      component: () => import('../activityEventInfo.vue'),
      meta: {
        auth: false, //标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
      },
    }, {
      path: 'newsList',
      name: '新闻列表wap',
      component: () => import('../newsList.vue'),
      meta: {
        auth: false, //标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
        //页面是否需要缓存
        // keepAlive:true
      },
    }, {
      path: 'newsDetails',
      name: '新闻详情wap',
      component: () => import('../newsDetails.vue'),
      meta: {
        auth: false, //标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
      },
    }, {
      path: 'contact',
      name: '联系我们wap',
      component: () => import('../contact'),
      meta: {
        auth: false, //标明是否需要登录后才能访问
        showLogin: true, // 是否显示底部登录注册按钮
      },
    }, {
      path: 'payment',
      name: '支付wap',
      component: () => import('../payment.vue'),
      meta: {
        auth: true, //标明是否需要登录后才能访问
        showLogin: false, // 是否显示底部登录注册按钮
      },
    }, {
      path: 'alipay',
      name: '支付宝支付wap',
      component: () => import('../alipay.vue'),
      meta: {
        auth: true, //标明是否需要登录后才能访问
        showLogin: false, // 是否显示底部登录注册按钮
      }
    }, {
      path: 'forgetPwd',
      name: '找回密码wap',
      component: () => import('../forgetPwd.vue'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
      }
    }, {
      path: 'login',
      name: '账号登录wap',
      component: () => import('../login'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
      }
    }, {
      path: 'smslogin',
      name: '短信登录wap',
      component: () => import('../smsLogin'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
      }
    }, {
      path: 'smsCode',
      name: '短信验证码wap',
      component: () => import('../smeCode'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
      }
    }, {
      path: 'toRegister',
      name: '注册账号wap',
      component: () => import('../toRegister'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
      }
    }, {
      path: 'message',
      name: '消息中心wap',
      component: () => import('../message'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
      }
    }, {
      path: 'myProfile',
      name: '个人中心wap',
      component: () => import('../myProfile'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
      }
    }, {
      path: 'myEvaluation',
      name: '我的测评wap',
      component: () => import('../myEvaluation'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
        // keepAlive:true, //页面是否需要缓存

      }
    }, {
      path: 'myEvaluationHistory',
      name: '历史测评wap',
      component: () => import('../myEvaluationHistory'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
        // keepAlive:true, //页面是否需要缓存
      }
    }, {
      path: 'myCourse',
      name: '我的课程wap',
      component: () => import('../myCourse'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
        // keepAlive:true, //页面是否需要缓存
      }
    }, {
      path: 'myCert',
      name: '我的证书wap',
      component: () => import('../myCert'),
    }, {
      path: 'myActivity',
      name: '我的活动wap',
      component: () => import('../myActivity'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
        // keepAlive:true, //页面是否需要缓存
      }
    }, {
      path: 'myActivityHistory',
      name: '历史活动wap',
      component: () => import('../myActivityHistory'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
        // keepAlive:true, //页面是否需要缓存
      }
    }, {
      path: 'organizationCenter',
      name: '机构中心wap',
      component: () => import('../organizationCenter'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
      }
    }, {
      path: 'evaluationRelease',
      name: '测评发布wap-发布中',
      component: () => import('../evaluationRelease'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
      }
    }, {
      path: 'oddEvaluationRelease',
      name: '测评发布wap-已发布',
      component: () => import('../oddEvaluationRelease'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
        // keepAlive:true, //页面是否需要缓存

      }
    }, {
      path: 'viewRegistration',
      name: '查看报名wap',
      component: () => import('../viewRegistration'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
      }
    }, {
      path: 'activityRelease',
      name: '活动发布wap-发布中',
      component: () => import('../activityRelease'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
      }
    }, {
      path: 'oddActivityRelease',
      name: '活动发布wap-已发布',
      component: () => import('../oddActivityRelease'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
      }
    }, {
      path: 'activityRegistration',
      name: '活动报名wap-我报名的',
      component: () => import('../activityRegistration'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
      }
    }, {
      path: 'teacherManage',
      name: '教师/用户管理-教师列表',
      component: () => import('../teacherManage'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
      }
    }, {
      path: 'studentManage',
      name: '教师/用户管理-学生列表',
      component: () => import('../studentManage'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
      }
    }, {
      path: 'registrationRelease',
      name: '测评报名-我报名的',
      component: () => import('../registrationRelease'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
        // keepAlive:true, //页面是否需要缓存

      }
    }, {
      path: 'evaluationResults',
      name: '测评报名-测评成绩',
      component: () => import('../evaluationResults'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
        // keepAlive:true, //页面是否需要缓存
      }
    }, {
      path: 'scorelist',
      name: '测评成绩-成绩查询',
      component: () => import('../scorelist'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
      }
    }, {
      path: 'videoCourse',
      name: '视频课程-发布课程',
      component: () => import('../videoCourse'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
      }
    }, {
      path: 'oddVideoCourse',
      name: '视频课程-已发布课程',
      component: () => import('../oddVideoCourse'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
        // keepAlive:true, //页面是否需要缓存
      }
    },
    {
      path: 'courseUser',
      name: '视频课程-课程用户',
      component: () => import('../courseUser'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
      }
    },
    {
      path: 'batchGive',
      name: '视频课程-批量用户',
      component: () => import('../batchGive'),
      meta: {
        showLogin: false, // 是否显示底部登录注册按钮
      },
    },
    {
      path: 'terms',
      name: '网站注册协议',
      component: () => import('../terms'),
      meta: {
        // showLogin: false, // 是否显示底部登录注册按钮
      },
    }
  ]
}]


// WEBPACK FOOTER //
// ./src/pages/Mobile/router/Mobile.routes.js